
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/addPreset/addSection/components/addSectionContextMenu.scss.css.virtualfile';
        module.exports = {"contextMenu":"_contextMenu_bg7jf_7","contextMenuSymbol":"_contextMenuSymbol_bg7jf_14"};